module.exports = __webpack_public_path__ + "media/images/destroy-257a64402461acfd624ad9b9dd324eff.svg";